import React from 'react';

import { Header } from '../components/atoms';
import {
  ChangeName,
  ChangePassword,
  SettingsUser,
} from '../components/templates';

const SettingsPage = () => {
  return (
    <>
      <Header>설정</Header>
      <SettingsUser />
      <ChangeName />
      <ChangePassword />
    </>
  );
};

export default SettingsPage;
